export const COMPUTERS_MOBILE_BREAKPOINT = 960;

export const shouldShowHostSidebar = (width: number): boolean =>
  width > COMPUTERS_MOBILE_BREAKPOINT;
